__turbopack_context__.v({
  "icon": "_Tu0cW_icon",
  "item": "_Tu0cW_item",
  "link": "_Tu0cW_link",
  "list": "_Tu0cW_list",
});
